import { TreeAction, SET_TREE_TOUPDATE } from "./types";

export function setTreeToupdate(toupdate: boolean): TreeAction {
  if (toupdate) console.log("update tree");
  return {
    type: SET_TREE_TOUPDATE,
    toupdate,
  };
}
